import { ValidationErrorItem } from "joi";

export function validateFields(requestDetails: any, schema: any) {
  const result = schema.validate(requestDetails, {
    abortEarly: false,
    allowUnknown: true,
  });
  return (
    result.error &&
    result.error.details &&
    setErrorFromJoi(result.error.details)
  );
}

export function setErrorFromJoi(validationErrors: Array<ValidationErrorItem>) {
  let _erroObject: any = {};
  validationErrors.map((errorItem) => {
    if (errorItem.path.length > 2) {
      let propertyName: string = [errorItem.path[0]].toString();
      let arrayItemNo: string = [errorItem.path[1]].toString();

      // add property to the _erroObject if it doesn't exists.
      if (!_erroObject.hasOwnProperty(propertyName)) {
        _erroObject = {
          ..._erroObject,
          [errorItem.path[0]]: [],
        };
      }

      // generate missing array items to match indexes
      while (_erroObject[propertyName].length < arrayItemNo) {
        _erroObject[propertyName].push(null);
      }

      // retrieve currect objecct based on index and modify it.
      let arrayItem = _erroObject[propertyName][arrayItemNo];
      if (errorItem.context && errorItem.context.key) {
        arrayItem = arrayItem
          ? {
              ...arrayItem,
              [errorItem.context.key]: errorItem.context.label,
            }
          : {
              [errorItem.context.key]: errorItem.context.label,
            };
      }

      // add or modify the above object to the _erroObject
      if (!_erroObject[propertyName][arrayItemNo]) {
        _erroObject[propertyName].push(arrayItem);
      } else {
        _erroObject[propertyName][arrayItemNo] = arrayItem;
      }

      //propertyName.push()
    } else {
      if (errorItem.context && errorItem.context.key) {
        _erroObject = {
          ..._erroObject,
          [errorItem.context.key]: errorItem.context.label,
        };
      }
    }
  });
  return _erroObject;
}
